export default import.meta.ROLLDOWN_FILE_URL_r8A0SlYVjfziQBbwLXlDeQ